import React, { ReactElement } from 'react';
import { Helmet } from 'react-helmet';
import TrackableLink from '../TrackableLink';

const NotFound = (): ReactElement => (
  <>
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
    <div>
      <h1>404 - Not Found!</h1>
      <TrackableLink to="/">Go Home</TrackableLink>
    </div>
  </>
);

export default NotFound;
